import React from 'react';
import './Tooltip.scss';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { useBrandingContext } from 'app-context/BrandingsContext';

const Tooltip = ({
  content,
  children,
  red,
  placement,
  disabled,
  className,
}) => {
  const tooltipClass = red ? 'red-tooltip' : '';
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;

  return (
    <Tippy
      arrow={false}
      content={content || null}
      className={`${tooltipClass} ${className}`}
      placement={placement || 'bottom'}
      style={{ backgroundColor: page_TextColor }}
      disabled={disabled}
    >
      <span>{children}</span>
    </Tippy>
  );
};

export default Tooltip;
